var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLegacy1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 48.0083,
    height: 23.4724,
    viewBox: "0 0 48.0083 23.4724",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.39012 9.88297L22.5831 20.8985L38.2011 12.9608C39.0773 12.5164 40.1105 12.4832 40.9908 12.6452L46.9586 14.7137C47.7149 14.9754 48.1489 15.5901 47.967 16.3336C47.7769 17.1311 46.9999 17.5174 46.1692 17.2391L39.8253 15.1L23.9634 23.1789C23.0459 23.6483 21.864 23.5278 20.9547 23.0086L2.27012 12.3046C0.232624 11.1374 -0.552618 8.80716 0.406202 6.74278C1.25757 4.91931 3.80754 3.51121 5.83677 4.61194L16.4995 10.4063C17.1277 8.58286 18.5701 7.61921 20.2315 6.80924L33.4607 0.37933C34.4443 -0.0983436 35.49 -0.0858827 36.5025 0.200722L46.8264 3.09584C47.5248 3.29106 47.9133 4.03873 47.7893 4.63686C47.6281 5.40114 46.8801 5.85389 46.0659 5.62544L35.0271 2.55586L21.1779 9.3056C20.2025 9.77912 19.2644 10.2651 18.9627 11.4531C18.8139 12.0346 19.3429 12.8155 19.7562 13.1311C20.3431 13.5756 21.244 13.4634 21.9218 13.1104L29.0592 9.38452C29.6048 9.10207 30.4107 9.38452 30.7372 9.82481C31.0637 10.2651 31.0389 11.3243 30.4148 11.6483C27.6375 13.1104 24.9925 14.5932 22.1285 15.8601C20.0951 16.7573 17.7187 15.4198 16.7475 13.5673L4.75809 6.98785C4.05964 6.60571 3.01403 7.35752 2.79085 7.86012C2.51395 8.48317 2.63794 9.45929 3.38185 9.88297H3.39012Z",
    fill: "#94F608"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLegacy1);
export default __webpack_public_path__ + "static/media/icon-legacy-1.71b9bfa91dccaa079a7a26881953f863.svg";
export { ForwardRef as ReactComponent };